
























import { Component, Vue } from 'vue-property-decorator';
import store from '../store';

export default {
	props: ['tag', 'title', 'position', 'active'],
	mounted() {
		const targets = [];
		const observer = [];

		const options = {
			root: null,
			rootMargin: '-100px',
			threshold: 1,
		};

		const dots = document.querySelectorAll('.dots__dot-holder');

		dots.forEach((element, i) => {
			observer[i] = new IntersectionObserver(
				(entries) => {
					if (entries[0].intersectionRatio > 0 && entries[0].boundingClientRect.top > 200) {
						dots.forEach((removeElement) => {
							// add remove pulsing class.
							removeElement.children[0].classList.remove('dots__dot--pulsing');
						});
						entries[0].target.children[0].classList.add('dots__dot--pulsing');
					}
				}, options,
			);

			targets[i] = element;
			observer[i].observe(targets[i]);
		});
	},
	methods: {
		updateModal() {
			store.dispatch('modalContent', { modalTag: this.tag });

			// Query body tag we can't reach within Vue.
			const body = document.querySelector('body');
			body.className = 'modal-open';
		},
	},
};

